import moment from 'moment';
import React from 'react';

import {DATE_WITH_TIME_DOTS_SECONDS_24} from 'shared/constants/date-format';

export interface IDateListItemProps {
    date?: string | null;
    dateFormat?: string;
}

export const DateListItem = ({date, dateFormat}: IDateListItemProps) => (
    <div>{date ? moment(date).format(dateFormat || DATE_WITH_TIME_DOTS_SECONDS_24) : '-'}</div>
);
